export default __webpack_public_path__ + "static/media/Mastr-Plan-Galleria.5d1ea03f.jpg";